export default __webpack_public_path__ + "static/media/portfolio4.ffb955f9.webp";